export class UtilsArray{
    static processAll(fn){
        return (dataArray)=>dataArray.map(data => fn(data))
    }
}